import { render, staticRenderFns } from "./ModelStudio.vue?vue&type=template&id=70aa0587&"
import script from "./ModelStudio.vue?vue&type=script&lang=js&"
export * from "./ModelStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports